// extracted by mini-css-extract-plugin
module.exports = {"view":"Calendar_view__QaNH-","calendar":"Calendar_calendar__2QSeq"};